import React from "react";
import { RaisedButton, FontIcon } from "material-ui";
import ScanPassOverlay from "../overlays/scan-pass.jsx";

class ScanPassButton extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false
    };
  }

  static contextTypes = {
    router: React.PropTypes.object.isRequired,
    tenant: React.PropTypes.object,
    isLarge: React.PropTypes.bool
  };

  getStyles() {
    return {
      iconButton: {
        height: "100%",
        display: "inline-block",
        verticalAlign: -1,
        lineHeight: "36px",
        fontSize: 15
      },
      qrCodeIcon: {
        marginLeft: -4,
        paddingRight: 16,
        color: this.context.tenant.invert_colors ? "#000" : "#fff"
      }
    };
  }

  render() {
    // Sundance inline style included because this version of Material UI strips out the alpha
    // channel from the style sheet and they need the background color alpha channel to work
    let { passId, style, label, disabled } = this.props,
      styles = this.getStyles(),
      button = (
        <RaisedButton
          className="eventive__scan-pass-button__button"
          disabled={disabled}
          label={label || "Show QR code"}
          labelPosition="before"
          primary={true}
          style={this.context.tenant && this.context.tenant.sundance_login ? { backgroundColor: "rgba(255, 255, 255, 0.4)" } : {}}
          onClick={() => {
            this.setState({ open: true });
          }}
        >
          {/*<FontIcon
            className="icon-qrcode"
            style={Object.assign({}, styles.iconButton, styles.qrCodeIcon)}
          />*/}
        </RaisedButton>
      );

    return (
      <div
        className="eventive__scan-pass-button__container"
        data-button-mode="pass"
      >
        {this.state.open ? (
          <ScanPassOverlay
            params={{ passId }}
            onCancel={() => this.setState({ open: false })}
          />
        ) : null}
        {button}
      </div>
    );
  }
}

export default ScanPassButton;



// WEBPACK FOOTER //
// ./src/app/components/partials/scan-pass-button.jsx